let $formAuth = $('.form-auth');
let $formAuthConfirm = $('.form-auth-confirm');

$(document).ready(function () {
	let tmInputPhone;
	/*$formAuth.find('input[name=phone]').on('input', function () {
		clearTimeout(tmInputPhone);

		let $self = $(this);
		let phone = $self.val();
		let phoneCleared = phone.replace(/\D/g, '');

		if (phoneCleared.length === 11) {
			tmInputPhone = setTimeout(function () {
				let params = {
					phone: phone
				};

				if (params.phone) {
					$.get('/auth/check_phone_exists', params, function (data) {
						if (data.phone_exists) {
							$formAuth.find('.auth-controls').slideDown();
							$formAuth.find('.to-register-controls').slideUp();
						} else {
							$formAuth.find('.auth-controls').slideUp();
							$formAuth.find('.to-register-controls').slideDown();
						}
					});
				}
			}, 500);
		}
	});*/

	$formAuth.find('.btn-to-reg').click(function () {
		let phone = $formAuth.find('[name=phone]').val();
		location.href = $(this).attr('href') + '?submit-form=1&phone=' + phone;
		return false;
	});

	$formAuth.submit(function () {
		let route = $(this).attr('action');
		let params = $(this).serializeArray();

		Auth.clearMsg($formAuth);

		$.post(route, params, function (data) {
			if (data.error) {
				Auth.errorMsg($formAuth, data.msg);
				$formAuth.trigger('reload-btn');
			} else {
				$formAuthConfirm.find('[name=phone]').val(data.phone);
				$formAuthConfirm.show();
				$formAuthConfirm.find('input:visible').first().focus();
				$formAuth.hide();
			}
		});

		return false;
	});

	$formAuthConfirm.submit(function () {
		let route = $(this).attr('action');
		let params = $(this).serializeArray();

		Auth.clearMsg($formAuthConfirm);

		$.post(route, params, function (data) {
			if (data.error) {
				Auth.errorMsg($formAuthConfirm, data.msg);
				$formAuthConfirm.trigger('reload-btn');
			} else {
				location.href = data.redirect_to;
			}
		});

		return false;
	})
});
